import React from "react";
import {PageRouteProvider, ReactUtility} from "@reapptor-apps/reapptor-react-common";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import PageDefinitions from "@/providers/PageDefinitions";
import Localizer from "@/localization/Localizer";

import styles from "./Call.module.scss";

export interface ICallProps {
}

interface ICallState {
}

export default class Call extends CruiseWizardPage<ICallProps, ICallState> {

    state: ICallState = {
    };
    
    private get phone(): string {
        return this.wizard.country?.contactPhone || this.settings.contactPhone || "";
    }
    
    public get navigation(): boolean {
        return false;
    }
    
    public async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        
        this.wizard.call = false;
        this.saveContext();
    }

    public async prevAsync(): Promise<void> {
        await PageRouteProvider.redirectAsync(PageDefinitions.cruiseWizardStartRoute);
    }

    public renderContent(): React.ReactNode {
        return (
            <div className={styles.call}>
                
                <p>{ReactUtility.toMultiLines(Localizer.cruiseWizardCallInstruction)}</p>
                <p>{this.phone}</p>

            </div>
        );
    }
}